import { Agentation } from 'agentation';
import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

// Dashboard Pages
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Settings from './pages/Settings';

function App() {
  const [sessionId, setSessionId] = useState<string | null>(null);
  const apiEndpoint = import.meta.env.VITE_API_ENDPOINT || 'http://localhost:8787';
  const agentationEndpoint = import.meta.env.VITE_AGENTATION_ENDPOINT || 'http://localhost:4747';

  return (
    <BrowserRouter>
      <div className="app">
        {/* Navigation */}
        <nav className="sidebar">
          <div className="logo">SV9 Dashboard</div>
          <ul>
            <li><Link to="/">Dashboard</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/orders">Orders</Link></li>
            <li><Link to="/settings">Settings</Link></li>
          </ul>
          {sessionId && (
            <div className="session-info">
              Session: {sessionId.slice(0, 8)}...
            </div>
          )}
        </nav>

        {/* Main Content */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Dashboard apiEndpoint={apiEndpoint} />} />
            <Route path="/products" element={<Products apiEndpoint={apiEndpoint} />} />
            <Route path="/orders" element={<Orders apiEndpoint={apiEndpoint} />} />
            <Route path="/settings" element={<Settings apiEndpoint={apiEndpoint} />} />
          </Routes>
        </main>

        {/* Agentation Component - Visual Feedback Tool */}
        {process.env.NODE_ENV === 'development' && (
          <Agentation
            endpoint={agentationEndpoint}
            onSessionCreated={(id) => {
              console.log('Agentation session:', id);
              setSessionId(id);
            }}
            onAnnotationAdded={(annotation) => {
              console.log('New annotation:', annotation);
            }}
          />
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
